module.exports = __webpack_public_path__ + "static/media/maxie.3ee63068.svg";